<script>
	export default {
		data() {
			return {
				shape: null,
			}
		},

		props: {
			google: Object,
			map: Object,
			geometry: {
				type: Array,
				required: true
			}
		},

		created() {
			// const { Data } = this.google.maps.Data
			// const { Feature } = this.google.maps.Data.Feature
			this.shape = this.google.maps.Polygon({
				paths: [
					{lat: 25.774, lng: -80.190},
					{lat: 18.466, lng: -66.118},
					{lat: 32.321, lng: -64.757}
				],
				map: this.map,
				strokeColor: '#FF0000',
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: '#FF0000',
				fillOpacity: 0.35,
				// draggable: true,
				// geodesic: true
			})

			// this.feature = new this.google.maps.Data.Feature(geometry)
			//
			// Data.add(this.feature)
		},

		render() {}
	}
</script>
